import React from 'react'
import {observer} from 'mobx-react'
import {Modal} from '../../../../components/modal'
import {Button, Flex, Text, useDisclosure} from '../../../../vanilla'
import {modalFooterButton} from '../changing-slot-warning-modal/styles.css'
import {useRapidDeliveryStore} from '../../../../store/hooks/useStore'
import { isMobile } from '../../../../utils/utils'

type ChangeDeliveryTypeModalProps = ReturnType<typeof useDisclosure> & {
  onConfirm?: () => void
}

export const ChangeDeliveryTypeModal = observer(
  ({onConfirm, ...rest}: ChangeDeliveryTypeModalProps) => {
    const {isRapidDeliveryBooked} = useRapidDeliveryStore()

    const getTextForDeliveryType = () => {
      if (isRapidDeliveryBooked) {
        return {
          heading: 'Change Your Delivery?',
          text: (
            <Text variant="unstyled">
              Some prices and products are only available with <strong>Rapid Delivery</strong>. Items already in your basket may change or become unavailable.
            </Text>
          )
        }
      }

      return {
        heading: 'Change to Rapid Delivery?',
        text: (
          <Text variant="unstyled">
            Some items in your basket may change price or become unavailable for <strong>Rapid Delivery</strong>. Your current slot will be released, and you'll need to book a new slot if you change your mind.
          </Text>
        )
      }
    }

    const deliveryTypeText = getTextForDeliveryType()

    return (
      <Modal
        size={isMobile() ? 'bottom-sm' : 'lg'}
        allowScroll={true}
        dataTestSelector="change-delivery-type-modal"
        title={deliveryTypeText.heading}
        showTitleBorder={false}
        {...rest}
      >
        <Flex
          width="full"
          marginX="auto"
          bg="white"
          gap="12px"
          justify="center"
          alignItems="center"
          paddingX="24px"
          paddingBottom="16px"
          data-test-selector="change-delivery-type-modal-content"
        >
          {deliveryTypeText.text}
        </Flex>

        <Flex
          gap={['12px', '12px', '20px']}
          align="center"
          justify={['flex-start', 'flex-start', 'flex-end']}
          direction={['column-reverse', 'column-reverse', 'row']}
          padding="16px"
        >
          <Button
            size="sm"
            width={['full', 'full', 'auto']}
            variant="outlinePrimary"
            onClick={rest.onClose}
            extraClassName={modalFooterButton}
            data-test-selector="cancel-delivery-type-change"
          >
            Cancel
          </Button>
          <Button
            size="sm"
            width={['full', 'full', 'auto']}
            variant="primary"
            onClick={() => {
              onConfirm?.()
              rest.onClose()
            }}
            extraClassName={modalFooterButton}
            data-test-selector="confirm-delivery-type-change"
          >
            Change Delivery
          </Button>
        </Flex>
      </Modal>
    )
  }
)
